module.exports = __webpack_public_path__ + "img/cart.25428c74.svg";